"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const PersonAdd = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 12,
  height: 10,
  viewBox: "0 0 12 10"
}, props), _react.default.createElement("path", {
  d: "M9.575 3.75V3.2a.625.625 0 1 1 1.25 0v.55h.55a.625.625 0 1 1 0 1.25h-.55v.55a.625.625 0 1 1-1.25 0V5h-.55a.625.625 0 1 1 0-1.25h.55zM8.4 9.531a.482.482 0 0 1-.494.469H.494A.482.482 0 0 1 0 9.531v-.937C0 7.299 1.106 6.25 2.47 6.25h3.46c1.364 0 2.47 1.05 2.47 2.344v.937zM4.2 5C2.875 5 1.8 3.88 1.8 2.5S2.875 0 4.2 0s2.4 1.12 2.4 2.5S5.525 5 4.2 5z",
  className: "fill"
}));

var _default = PersonAdd;
exports.default = _default;